'use client';

import {CareerAcceleratorsByCourseIds} from '@udemy-v2/career-accelerators';
import React, {createContext, useContext, ReactNode} from 'react';

const CourseCareerAcceleratorContext = createContext<CareerAcceleratorsByCourseIds | undefined>(
    undefined,
);

interface CourseCareerAcceleratorProviderProps {
    children: ReactNode;
    courseCareerAccelerator?: CareerAcceleratorsByCourseIds;
}

export function CourseCareerAcceleratorProvider({
    children,
    courseCareerAccelerator,
}: CourseCareerAcceleratorProviderProps) {
    return (
        <CourseCareerAcceleratorContext.Provider value={courseCareerAccelerator}>
            {children}
        </CourseCareerAcceleratorContext.Provider>
    );
}

export function useCourseCareerAccelerator() {
    return useContext(CourseCareerAcceleratorContext);
}
